import React, {useState} from 'react';
import {Box, Button, Typography} from '@mui/material';

interface ExpandableTextProps {
    value: string;
    maxChars: number;
    typographySx?: object;
}

const ExpandableText = ({value, maxChars, typographySx}: ExpandableTextProps) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const shouldClamp = value.length > maxChars;
    const displayedValue = shouldClamp && !isExpanded ? `${value.slice(0, maxChars).trimEnd()}...` : value;

    return (
        <Box sx={{minWidth: 0}}>
            <Typography sx={{overflowWrap: 'anywhere', ...typographySx}}>{displayedValue}</Typography>
            {shouldClamp && (
                <Button
                    variant="text"
                    size="small"
                    sx={{minWidth: 0, p: 0, mt: 0.5, textTransform: 'none'}}
                    onClick={event => {
                        event.stopPropagation();
                        setIsExpanded(previous => !previous);
                    }}>
                    {isExpanded ? 'Show less' : 'See all'}
                </Button>
            )}
        </Box>
    );
};

export default ExpandableText;
